module.exports = __webpack_public_path__ + "img/no_image.0aaa7bc5.jpg";